/* Publish by EComposer at 2026-09-30 18:49:48*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vimo9qsioq"]=  window.__ectimmers["ecom-vimo9qsioq"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vimo9qsioq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vimo9qsioq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6qwr0e0viq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6qwr0e0viq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n82ewv7kbgt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n82ewv7kbgt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7p20qhi0ac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7p20qhi0ac', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oodb8m3o8wg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oodb8m3o8wg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-78kajya717t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-78kajya717t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jd40upckqpa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jd40upckqpa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmzdokpf97d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmzdokpf97d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pzhp98p691a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pzhp98p691a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r33vvq2mdth').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r33vvq2mdth', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dt4q9ulp2pe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dt4q9ulp2pe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pkfgnll1i3p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pkfgnll1i3p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c305tc1oc1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c305tc1oc1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ew4nxfk1k45').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ew4nxfk1k45', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2tx1mfy6qdg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2tx1mfy6qdg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fn610699jll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fn610699jll', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eb0xjaq140b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eb0xjaq140b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-484wfix9gij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-484wfix9gij', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-96l29ss4lt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-96l29ss4lt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ec2du748bj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ec2du748bj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2escu8mg3m8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2escu8mg3m8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2in1t4s2voa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2in1t4s2voa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2j0xmfnoukg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2j0xmfnoukg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0p0xxuagwn5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0p0xxuagwn5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-695uvrpevk7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-695uvrpevk7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-io28zf5c1xq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-io28zf5c1xq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-34pdnzum4dd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34pdnzum4dd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a7238i7b717').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a7238i7b717', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c8xjo8o56dn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c8xjo8o56dn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ob1t33mzcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ob1t33mzcm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ttzde5mkyr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ttzde5mkyr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gnulkfe87gj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gnulkfe87gj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k4fr4a13sk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k4fr4a13sk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9j25ccqwkrq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9j25ccqwkrq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-87xin07j4d7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-87xin07j4d7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g6m5wz7p709').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g6m5wz7p709', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i0ax5096x6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i0ax5096x6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1tzxjt7caxp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1tzxjt7caxp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qpiouo9cipf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qpiouo9cipf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cjru46tyxee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cjru46tyxee', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kqx5qv8m6z8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kqx5qv8m6z8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o8b1qu8ku5i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o8b1qu8ku5i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pa7y7t1uwxq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pa7y7t1uwxq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-melbuyqtlc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-melbuyqtlc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ju6ecw0hd2i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ju6ecw0hd2i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ttl19gujq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ttl19gujq9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ewixeztqo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ewixeztqo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g60z7428ohv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g60z7428ohv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzcdxlcotrm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzcdxlcotrm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uft8dbgfsio').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uft8dbgfsio', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2dqor9mfzls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2dqor9mfzls', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-934oiyo5un9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-934oiyo5un9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pa4vsvjx1z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pa4vsvjx1z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3nd8trw8615').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3nd8trw8615', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vvkhku31pdl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vvkhku31pdl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aykvniak89s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aykvniak89s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c3xt6luqtjh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c3xt6luqtjh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j8y5v5s9bco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j8y5v5s9bco', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xov5p9lnaun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xov5p9lnaun', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5s5mqu6y4ip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5s5mqu6y4ip', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rdpfnols2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rdpfnols2j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-25jqsjx6ovn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-25jqsjx6ovn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rm3n3ry44l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rm3n3ry44l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6rvzuf2lhtn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6rvzuf2lhtn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbwr6887eyl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbwr6887eyl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qg7rbzqqmd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qg7rbzqqmd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-71hzp17aoks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-71hzp17aoks', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j4qi1c9s4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4qi1c9s4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vx6t9pxqa1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vx6t9pxqa1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-25doqpfb17r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-25doqpfb17r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jffz3e2nmhm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jffz3e2nmhm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-phq15d4doc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-phq15d4doc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mf85rytrknk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mf85rytrknk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uttstbyw7x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uttstbyw7x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v1h7a6nx0hi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v1h7a6nx0hi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qnd0a1pp4ki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qnd0a1pp4ki', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mryam199lt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mryam199lt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aok601jpuck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aok601jpuck', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-54fmgu01xbx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-54fmgu01xbx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1pc94kwtiye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1pc94kwtiye', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-443lglinale').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-443lglinale', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6zvy8442zy8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6zvy8442zy8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-is1eth1733o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-is1eth1733o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2f9c1gzjr09').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2f9c1gzjr09', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iyhr4rxvxgs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iyhr4rxvxgs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uhb9zigqdx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uhb9zigqdx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dn24a5f1985').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dn24a5f1985', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l6n6p988irj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6n6p988irj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5dab7odxq44').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5dab7odxq44', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ndfih6tf7o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ndfih6tf7o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8s9ag1m4kq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8s9ag1m4kq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ejwh4g7hy8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ejwh4g7hy8t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7eqkezoffe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7eqkezoffe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khv0qyff2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khv0qyff2f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wq7i6erb9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wq7i6erb9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-29ap2r2dmtq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-29ap2r2dmtq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jt05xk33kpg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jt05xk33kpg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sbleeegxpoe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sbleeegxpoe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3t7t4bu3g1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3t7t4bu3g1o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-82w91774b7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-82w91774b7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0nv8y3ek54jp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0nv8y3ek54jp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3smqnhx7u0g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3smqnhx7u0g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ey3qqete4ut').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ey3qqete4ut', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c4jfrld17dw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4jfrld17dw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x3ie19bet2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x3ie19bet2l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93cuilfbklc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93cuilfbklc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z3rkgouz4v8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z3rkgouz4v8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zc6ztlga3f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zc6ztlga3f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sqwxe9cvvkk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sqwxe9cvvkk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wm8r1udv9n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wm8r1udv9n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jf97ao62yle').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jf97ao62yle', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m93ik5z534g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m93ik5z534g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7v9hntgm9v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7v9hntgm9v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ymh0dcom6j8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ymh0dcom6j8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5i1oqwxpayn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5i1oqwxpayn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nr5t5hd5u7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nr5t5hd5u7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4p9bkofuwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4p9bkofuwd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nx8ni2vxgsj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nx8ni2vxgsj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gxgxwkyuk7t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gxgxwkyuk7t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ucaz3rv9cog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ucaz3rv9cog', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vmmvkgmjsia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vmmvkgmjsia', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mn2przlh2h7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mn2przlh2h7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4zft9lpuo8w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4zft9lpuo8w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r5wud5ewyed').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r5wud5ewyed', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p7p2ir8wp5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p7p2ir8wp5d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-664ohk0ow8u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-664ohk0ow8u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wv22i2xmubr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wv22i2xmubr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-emhv11ofn9d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-emhv11ofn9d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bpanxjf8tls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bpanxjf8tls', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7mounp8yasu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7mounp8yasu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m1n6tdauqid').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m1n6tdauqid', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mmzdj9qfjh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mmzdj9qfjh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mmkpopokfgj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mmkpopokfgj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-felf1zvlnfw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-felf1zvlnfw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2dr8dudziyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2dr8dudziyh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0glcqxkysz76').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0glcqxkysz76', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kluwl8mo67l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kluwl8mo67l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ed1hckxdn3v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ed1hckxdn3v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1lesoky1b8o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1lesoky1b8o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tombxatobu7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tombxatobu7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4d4lliwsj3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4d4lliwsj3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-upfz3xzlq6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-upfz3xzlq6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t10zvnrh2e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t10zvnrh2e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iudcabg0xl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iudcabg0xl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wnkxac7089d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wnkxac7089d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vq6uppszmbr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vq6uppszmbr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pdxm0ihbiii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdxm0ihbiii', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vn9p6vn0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vn9p6vn0s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lq8lpnrjqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lq8lpnrjqm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9cxnr5pzgcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9cxnr5pzgcm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lv30z090g5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lv30z090g5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kbjfc15hobm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kbjfc15hobm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-52zpdb0ypk8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52zpdb0ypk8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nz1hs5lipzf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nz1hs5lipzf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-038r8lhxuzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-038r8lhxuzb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-74lzs0nexo9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-74lzs0nexo9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vf66kbdh8f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vf66kbdh8f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uqph7z82hye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uqph7z82hye', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y1q1qo0xtyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y1q1qo0xtyi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lob35msge9e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lob35msge9e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ebmgvyi1zo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ebmgvyi1zo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b8mq95130g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b8mq95130g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sjj1s41sbz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sjj1s41sbz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ik34nlh3to').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ik34nlh3to', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7vmevdeyohh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7vmevdeyohh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tz4w4shjcah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tz4w4shjcah', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gwbpn6oni1c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gwbpn6oni1c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bg3dk31zxpv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bg3dk31zxpv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5hkahisxjcg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5hkahisxjcg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bfpytlaj60w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bfpytlaj60w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zmh2w6tmx0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zmh2w6tmx0d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-silc241ae0r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-silc241ae0r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9vb7khh6xv6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9vb7khh6xv6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0w5x2ul14c7s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0w5x2ul14c7s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ys0nhvdn5nq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ys0nhvdn5nq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-90ncrmsed5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-90ncrmsed5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20upa1pqt1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20upa1pqt1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fkaeajx9blr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fkaeajx9blr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ho7h1yy4i3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ho7h1yy4i3c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-knhbb0qexmh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-knhbb0qexmh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tqxgs3vvuy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tqxgs3vvuy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c325wr62mau').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c325wr62mau', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-360d0fugm28').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-360d0fugm28', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kj5sxxz25t8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kj5sxxz25t8', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2n19bpcfsaa"]=  window.__ectimmers["ecom-2n19bpcfsaa"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-2n19bpcfsaa"]["rhymgob17"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-2n19bpcfsaa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2n19bpcfsaa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3tiao2m0mnk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3tiao2m0mnk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d37pe0ay664').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d37pe0ay664', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l9x35axb5ck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l9x35axb5ck', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4tcs0k9ytgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4tcs0k9ytgi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2jgfgnevckf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2jgfgnevckf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jduiwns0i4k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jduiwns0i4k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65ytbslkeju').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65ytbslkeju', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xt616ki8s3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xt616ki8s3c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6lors4emmti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6lors4emmti', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fho254bk8ud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fho254bk8ud', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jzgp709lmre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jzgp709lmre', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r0n1d3hqrki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0n1d3hqrki', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-adfqpr2egoo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-adfqpr2egoo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-52zz1nl6v6f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52zz1nl6v6f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-otzcx4slk1n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-otzcx4slk1n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8mf4gj9fwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8mf4gj9fwl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-axiake7l0u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-axiake7l0u', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lgol4r6uidf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lgol4r6uidf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ds0kosiybbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ds0kosiybbk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9elyudy5uh8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9elyudy5uh8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eckjjttc4rb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eckjjttc4rb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gkjvkr2p7x4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gkjvkr2p7x4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oezykkof03r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oezykkof03r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9wbp7y10xal').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9wbp7y10xal', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jayuqsybyz8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jayuqsybyz8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hpt8r1uk4r4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hpt8r1uk4r4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jxhq2kbwoe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jxhq2kbwoe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-irpvgwrnoom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-irpvgwrnoom', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aqtsxfew4tk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aqtsxfew4tk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8n5biazcgdm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8n5biazcgdm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fsiqnbb1ku').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fsiqnbb1ku', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23yvbc7sqixh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23yvbc7sqixh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8nhe8q2dy2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8nhe8q2dy2b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7vzlz6pnesy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7vzlz6pnesy', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8xndxwwfcvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8xndxwwfcvp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sfhk7img4i9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sfhk7img4i9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7mvuttr36nn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7mvuttr36nn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8d7wspk15l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8d7wspk15l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7tb247bxl3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7tb247bxl3o', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-acitts62rq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-acitts62rq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-smaf42vl0ts').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-smaf42vl0ts', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eosla4y6nnb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eosla4y6nnb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6q9wl1leab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6q9wl1leab', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1rwdip2tcug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1rwdip2tcug', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iqmevjp9dee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iqmevjp9dee', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wkjkdqjsrhb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wkjkdqjsrhb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yuv030y7bc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yuv030y7bc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-77jx0ap5ylo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-77jx0ap5ylo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qpw6b8e6zx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qpw6b8e6zx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c0h5j7lut8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c0h5j7lut8p', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mfv5aajvckl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mfv5aajvckl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3gl8ce7ksng').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3gl8ce7ksng', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kepl3sv06fg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kepl3sv06fg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hiqdejn7xyo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hiqdejn7xyo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qksjkbu498j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qksjkbu498j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qqrzoguu5f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qqrzoguu5f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pesytr07r8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pesytr07r8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-61yfnii3yl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-61yfnii3yl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xvlp43z8we').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xvlp43z8we', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-skybol739bk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-skybol739bk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xvd2ndn8bd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xvd2ndn8bd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cwfwufu07j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cwfwufu07j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r5yp4rts7e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r5yp4rts7e', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a0gxa88t5pe"]=  window.__ectimmers["ecom-a0gxa88t5pe"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,n=($=this.settings.disable_auto_close__tablet)!=null?$:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(L){return o&&L<768||n&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let U=null;function G(oe){U||(U=oe);const se=Math.min((oe-U)/Z,1),Y=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*Y),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,U=Z.querySelector(":scope > .ecom-accordion__body");!r&&U&&U.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");U&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{U.style.height=U.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),Y=this.parentNode,de=Y.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),te=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=_(se);if(q)J?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let fe=Y.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&te&&te.classList.add("ecom-effect-accodion"),b(te)}window.dispatchEvent(new window.Event("renderScroll"));const X=this,ue=s||se>1024;function K(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(X)&&k(X)}if(ue&&!r){let fe;const Te=function(ze){ze.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),K()},600)}else requestAnimationFrame(()=>{setTimeout(K,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-a0gxa88t5pe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a0gxa88t5pe', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wfaoze1zh2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wfaoze1zh2', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gzp8bf8wutt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gzp8bf8wutt', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-umkbqc6qkg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-umkbqc6qkg', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tpjxk0y9ahl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tpjxk0y9ahl', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fuwot1gdnps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fuwot1gdnps', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zsfwh7ilr0h"]=  window.__ectimmers["ecom-zsfwh7ilr0h"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-zsfwh7ilr0h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zsfwh7ilr0h', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kuxuakq7czr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kuxuakq7czr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3mha10rp11d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3mha10rp11d', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lhh10pk3kfc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lhh10pk3kfc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mkx8tk1adlg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mkx8tk1adlg', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vhqj5uj6lfs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vhqj5uj6lfs', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmdugkm4bv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmdugkm4bv', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gf447p1jvmj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gf447p1jvmj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-an7ssmjujua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-an7ssmjujua', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5yarpguyjjj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5yarpguyjjj', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-susydyul5ri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-susydyul5ri', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-52a1bxutpt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52a1bxutpt', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-85s3y52rktr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-85s3y52rktr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ovgjhezoe1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ovgjhezoe1d', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ms62vf4r09').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ms62vf4r09', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j3ghkv913sq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j3ghkv913sq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ue92ydopfui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ue92ydopfui', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yef5u813i3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yef5u813i3n', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wz6j4hoo8c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wz6j4hoo8c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nf2oblst35k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nf2oblst35k', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3vwefll2ox4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3vwefll2ox4', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g7rzs0i1lj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g7rzs0i1lj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptmwxqhd5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptmwxqhd5s', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-86g3eoidq2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-86g3eoidq2f', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ppn7y4uq5y9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ppn7y4uq5y9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jbnrw6w5gc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jbnrw6w5gc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s6mm2e20rh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s6mm2e20rh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yqayf8atc7f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yqayf8atc7f', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bqu61n2ysui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bqu61n2ysui', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1l6b930jn7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1l6b930jn7c', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j88umw58prp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j88umw58prp', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o2nunj2mzyr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o2nunj2mzyr', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x7e6aprsnv7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x7e6aprsnv7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wpxprhy8w4h"]=  window.__ectimmers["ecom-wpxprhy8w4h"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,n=this.settings.autoplay,o=this.settings.lazyload||!1,s=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const m=t.querySelector(".ecom-video-poster");let g;g=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");o&&setTimeout(function(){b(_)},500);function b($){let A={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,A).observe($)}function y($,A){let I={handleMouseenter:j,handleMouseleave:T,handleEnded:L};function j(){$.readyState>=c&&$.pause()}function T(){$.readyState>=c&&$.play()}function L(){v($,I)}if(r){$.addEventListener("mouseenter",j),$.addEventListener("mouseleave",T);let O=t.querySelector(".ecom-video_link-extra");O&&O.href&&(O.addEventListener("mouseenter",j),O.addEventListener("mouseleave",T)),A||$.addEventListener("ended",L)}}function v($,A){if(A){const{handleMouseenter:I,handleMouseleave:j,handleEnded:T}=A;let L=t.querySelector(".ecom-video_link-extra");$.removeEventListener("mouseenter",I),$.removeEventListener("mouseleave",j),$.removeEventListener("ended",T),L&&L.href&&(L.removeEventListener("mouseenter",I),L.removeEventListener("mouseleave",j))}}function w($,A){$.forEach(function(I){if(I.isIntersecting){const j=I.target.querySelector("video source"),T=I.target.querySelector("video"),L=I.target.querySelector("iframe");if(T&&j&&(j.src=j.dataset.source,T.load(),T.addEventListener("loadeddata",function(){n&&T.play()})),L){let O=L.dataset.srcVideo;L.setAttribute("src",O)}A.unobserve(I.target)}})}let k=t.querySelector(".ecom_video"),S=t.querySelector(".ecom_iframe");a&&k.addEventListener("click",()=>{k.readyState>=c&&(k.paused?k.play():k.pause())}),n&&(d&&d.classList.remove("ecom-overlay"),g&&(g.style.display="none"),m&&(m.style.display="none")),k&&!i&&k.addEventListener("ended",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&k)m&&(m.style.display="none"),k.autoplay=!0,k.play(),d.classList.remove("ecom-overlay"),g.style.display="none";else if(S){let $=S.getAttribute("src");$.includes("autoplay=0")?$=$.replace("autoplay=0","autoplay=1"):$=$+"&autoplay=1",S.setAttribute("src",$),l?setTimeout(()=>{$=$.replace("autoplay=1","autoplay=0"),S.setAttribute("src",$)},100):(m&&(m.style.display="none"),d.classList.remove("ecom-overlay"),g.style.display="none")}}),k&&(e&&!m&&y(k,i),m&&m.addEventListener("click",function(){m.style.display="none",k.play(),e&&y(k,i)}),r||k.addEventListener("pause",function(){m&&(m.style.display="block"),d&&d.classList.add("ecom-overlay"),g&&(g.style.display="block")}),!s&&d&&k.addEventListener("click",function(){k.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function($){$.dataset.ecTrackingId&&$.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:$.id,tracking_id:$.dataset.ecTrackingId})},{once:!0})});const z=t.querySelector("[ecom-modal]");if(z&&this.settings.image_overlay&&l&&window.EComModal){const $=z.dataset.width,A=z.dataset.height;var E=this.id;new window.EComModal(z,{cssClass:[E,"ecom-core","ecom-core-simulator"],onOpen:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-modal-box__content");j.classList.add("ecom-element_video-iframe");const T={width:$,height:A};Object.assign(j.style,T)}},onClose:function(){var I=document.querySelector(".ecom-modal."+E);if(I){const j=I.querySelector(".ecom-element_video-iframe iframe");j&&(j.src="")}}})}

                    });
                    
                        document.querySelectorAll('.ecom-wpxprhy8w4h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wpxprhy8w4h', settings: {"loop":false,"autoplay":false,"player_controls":true,"click_to_play_pause":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-th5eh4k40dk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-th5eh4k40dk', settings: {"loop":false,"autoplay":false,"player_controls":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qbug66si4u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbug66si4u', settings: {"loop":false,"autoplay":false,"player_controls":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uqeiu7oxcha').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uqeiu7oxcha', settings: {"loop":false,"autoplay":false,"player_controls":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fj1x8nx2jdd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fj1x8nx2jdd', settings: {"loop":false,"autoplay":false,"player_controls":false,"source":"youtube","image_overlay":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}